module.exports = __webpack_public_path__ + "static/media/c-pop-up-1.66c203c9.png";